{
  "version": 1,
  "asset_id": "81cb63c5-b2f7-4ccc-b991-b22b1a072283",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/81cb63c5-b2f7-4ccc-b991-b22b1a072283/svc-ecommerce-seo-640.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/81cb63c5-b2f7-4ccc-b991-b22b1a072283/svc-ecommerce-seo-640.webp",
  "original_filename": "svc-ecommerce-seo-640.webp",
  "size": 17414,
  "content_type": "image/webp",
  "created_at": "2026-07-25T02:26:46Z"
}
